import { authClient } from '~/lib/auth-client'

export interface AuthUser {
    id: string
    email: string
    name?: string
}

/**
 * Central access to the authenticated admin/driver user, backed by Better Auth
 * (replaces supabase `useSupabaseUser`). SSR-safe: forwards the request cookie
 * when resolving the session on the server.
 */
export default function useAuthUser() {
    const user = useState<AuthUser | null>('authUser', () => null)

    async function refresh(): Promise<AuthUser | null> {
        const headers = import.meta.server ? useRequestHeaders(['cookie']) : undefined
        const { data } = await authClient.getSession(
            headers ? { fetchOptions: { headers } } : {},
        )
        user.value = data?.user
            ? { id: data.user.id, email: data.user.email, name: data.user.name }
            : null
        return user.value
    }

    return { user, refresh }
}
